import React from 'react';
import ReactDOM from 'react-dom'
import { hashHistory } from 'react-router';
import { Card, WingBlank, Badge, NavBar, Icon, WhiteSpace,ListView,Toast } from 'antd-mobile';
import './index.less';
import { carData } from '../data/carData'
import { getUrlParam, href } from '../../utils/util';
import {post} from '../../utils/request';
import api from './api'
import phone from './images/phone.png'
import jt from './images/jt.png'

function MyBody(props) {
  return (
    <div className="am-list-body my-body" style={{ backgroundColor: '#f3f4f5'}}>
      {props.children}
    </div>
  );
}

const NUM_SECTIONS = 5;
const NUM_ROWS_PER_SECTION = 5;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];
function genData(pIndex = 0) {
  for (let i = 0; i < NUM_SECTIONS; i++) {
    const ii = (pIndex * NUM_SECTIONS) + i;
    const sectionName = `Section ${ii}`;
    sectionIDs.push(sectionName);
    dataBlobs[sectionName] = sectionName;
    rowIDs[ii] = [];

    for (let jj = 0; jj < NUM_ROWS_PER_SECTION; jj++) {
      const rowName = `S${ii}, R${jj}`;
      rowIDs[ii].push(rowName);
      dataBlobs[rowName] = rowName;
    }
  }
  sectionIDs = [...sectionIDs];
  rowIDs = [...rowIDs];
}


class App extends React.Component {
    constructor(...args) {
        super(...args);
        const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
        const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
        const dataSource = new ListView.DataSource({
          getRowData,
          getSectionHeaderData: getSectionData,
          rowHasChanged: (row1, row2) => row1 !== row2,
          sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
        });
        let city = getUrlParam('city')

        sectionIDs = [];
        rowIDs = [];
        dataBlobs = {};
        pageIndex = 0;
        
        this.state = {
            urlOps: {},
            dataList:[],
            
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 5 / 4,
            data: [],
            skipCount: 0,
            pageSize: 5,
            city: city ? decodeURI(city) : '',
        };
    }
    componentWillMount() {     
      setTimeout(() => {
        genData();
        this.getCityData()
      }, 600);
    }
    getData(){
      let data = [
        {
          name:'杭州飞翔汽车有限公司',
          type:'1',
          tag:'轻卡,重卡,厢车',
          gps:[1,2],
          phone:'13666627127',
        }
      ]
      this.rData = genData(data);
      console.log(this.rData)
      this.setState({
        dataSource: this.state.dataSource.cloneWithRows(this.rData),
        dataList: data
      });
    }
    carTypeRender(){
      const dataArr = [carData[2],carData[3],carData[4],]
      let urlOps = this.state.urlOps
      return dataArr.map((obj,index) => {
        return <WingBlank size="lg" key={index} >
          <Card className='box' onClick={()=>{
              let url = ''
              url = `/MarketingOnlineDetail?id=${obj.id}&city=${this.state.selectCity}`;
              href(url)
          }}>
            <Card.Body>
              <div style={{ width: '320px', height: '164px',  background: 'url('+obj.detailImg+') no-repeat 0 0', backgroundSize: 'cover', borderRadius: '5px' }} ></div>
              <div className='title'>
                  {obj.name}
                  <div className="ZJ">
                      <Badge text={obj.type} style={{ padding: '0 3px', backgroundColor: '#fff', color: '#10C2B0',border: '1px solid #10C2B0', borderRadius: 2, fontWeight: 500 }} />
                  </div>
              </div>
              <div style={{ marginTop: '8px' }}>
                  
              </div>
            </Card.Body>
            <Card.Footer content={
              <div style={{ marginTop: '16px',marginBottom:'6px' }}>
                  <span style={{ color: '#999', marginRight: '8px' }}>续航</span>
                  <b className='km'>{obj.GKXH.join('/')}km</b>
              </div>
            } extra={<div>
              <div style={{ marginTop: '15px',marginBottom:'6px' }}>
                    <span style={{ color: '#999', marginRight: '8px' }}>载方</span>
                    <b className='km'>{obj.ZDZF.length >  0 ? obj.ZDZF.join('/')+'m³' : '-'}</b>
                    
                </div>
            </div>} />
          </Card>
          <WhiteSpace size="lg" />
        </WingBlank>      
      })

    }
    renderRow(){
      const {data} = this.state;

      let index = 0;
      const row = (rowData, sectionID, rowID) => {
        let obj = {};
        if(index <= data.length - 1){
            obj = data[index++];
        }else{
            return (<div></div>)
        }
        
        return (
          <div className='map' key={rowID}>
            <div className='top'>{ obj.name }</div>
            <div className='type'>服务车型：<span>{ obj.name }</span></div>
            <div className='tag'>服务车型：<span>{ obj.tag.join(',') }</span></div>
            <div className='icon'></div>
          </div>
        )
      }
      return row
    }
    onEndReached(){
      if (this.state.isLoading || !this.state.hasMore) {
        return;
      }
      this.setState({ isLoading: true });
      setTimeout(() => {
        pageIndex++;
        genData(pageIndex);
        this.setState({
          skipCount: pageIndex
        },()=>{
          this.getCityData(1)
        });
      }, 1000);
    }
    getCityData(type){
      const {skipCount, pageSize, city} = this.state;
      post({
          url: api.queryRecommendCarrierByCity,
          data: {
            // longitude: 'longitude',
            // latitude:'latitude',
            city:city,
            skipCount: skipCount * pageSize,
            pageSize: pageSize
          }
      }).then((res) => {
        console.log(res)
          if(res.result === 'success'){
            console.log(res.data)
            this.setState({
              data: res.data
            },()=>{

              if(sectionIDs.length >= res.count){
                this.setState({
                  hasMore: false
                });
              }

              if(type){
                this.setState({
                  dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
                  isLoading: false,
                });
              }else{
                const hei = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
                this.setState({
                  dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
                  isLoading: false,
                  height: hei,
                });
              }
            });
          }else{
          }
      },(res)=>{
        Toast.info(res.msg,1);
      })
    }
    render() {
      const {data} = this.state;
      console.log(data)
      let index = 0;
      const row = (rowData, sectionID, rowID) => {
        
        let obj = {};
        if(index <= data.length - 1){
            obj = data[index++];
        }else{
            return (<div></div>)
        }
        console.log(1)
        return (
          
          <div className="mapbox" key={rowID} >
              <div className='name'>{ obj.customerName }</div>
              <div className='type'>服务车型：<span></span></div>
              <div className='tag'><span>{ obj.recommendCarType }</span></div>
              <div className='icon'>
                <div className='phone'>
                  <img src={phone}></img>
                  <div><a href={`tel:${obj.recommendPhoneNumber}`}>电话</a></div>
                </div>
                {/* <div className='line'></div>
                <div className="jt">
                  <img src={jt}></img>
                  <div onClick={()=>{
                      let url = ''
                      url = `/MarketingOnlineMap?longitude=${obj.longitude}&latitude=${obj.latitude}`;
                      href(url)
                    }}>{obj.distance || '未知'}</div>
                </div> */}

                
              </div>
          </div>
          
        );
      };
  
  



        return (
            <div style={{ width: '100%', height: '100%' }} className="rentalCar">
                <NavBar
                  mode="light"
                  className='navbar'
                  leftContent="热门车型"
                  rightContent={[
                    <span style={{ cursor:'pointer' }} key="1" onClick={() => {
                      let url = '/MarketingOnlineHotCar'
                      href(url)
                    }}>更多</span>,
                    <Icon key="2" type="right" />
                  ]}
                ></NavBar>
                { this.carTypeRender() }
                <WingBlank size="lg"  >
                  <h3>推荐运营商</h3>
                  <ListView
                    ref={el => this.lv = el}
                    dataSource={this.state.dataSource}
                    renderFooter={() => (
                        <div style={{ padding: 35, textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                            {this.state.dataList && this.state.dataList.length > 0 ? '' : '更多运营商，敬请期待！'}
                        </div>
                    )}
                    renderBodyComponent={() => <MyBody />}
                    renderRow={row}
                    pageSize={5}
                    useBodyScroll
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached.bind(this)}
                    onEndReachedThreshold={10}
                  />
                </WingBlank>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/marketingOnline/rentalCar/index.js